import { createStyles, rem } from '@mantine/core'

export default createStyles(() => {
  return {
    heading: {},
    filterInput: {},
    cardWrapper: {
      padding: rem(4),
      minWidth: rem(264),
      alignItems: 'stretch',
    },
    listing: {},
  }
})
